import { isEqual } from 'lodash';
import React from 'react';
import { ComponentStylingInterface, PollUiComponentInterface } from '../../../../../interfaces/pagebuilder';
import { PageBuilderSettingsSection, PageBuilderSettingsTable } from '../PageBuilderSettingsTable';
import { useTranslation } from 'next-i18next';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';

const PollStyling = ({ component, onChange }: ComponentStylingInterface<PollUiComponentInterface>) => {
  const event = useSelector((state) => state.common.event ?? state.admin.event);
  const { t } = useTranslation();
  const settingSections: PageBuilderSettingsSection[] = [
    {
      settings: [
        {
          path: 'customStyling.backgroundColor',
          type: 'color',
          label: t('pagebuilder:background-color'),
          defaultValue: component?.customStyling?.backgroundColor ?? event?.template?.mainColor,
        },
        {
          path: 'customStyling.textColor',
          type: 'color',
          label: t('pagebuilder:text-color'),
          defaultValue: component?.customStyling?.textColor ?? event?.template?.mainButtonTextColor,
        },
      ],
    },
  ];
  return <PageBuilderSettingsTable component={component} onChange={onChange} sections={settingSections} />;
};
export default React.memo(PollStyling, (prevprop, newprop) => isEqual(prevprop, newprop));
